import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function FamilyProtectedRoute() {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);
  const [role, setRole] = useState(null);

  useEffect(() => {
    let alive = true;
    const ctrl = new AbortController();

    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
          credentials: "include",
          signal: ctrl.signal,
        });
        if (!alive) return;
        if (!res.ok) {
          setAuthed(false);
          setRole(null);
          return;
        }
        const data = await res.json();
        setAuthed(true);
        setRole(data?.role || null);
      } catch {
        if (!alive) return;
        setAuthed(false);
        setRole(null);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
      ctrl.abort();
    };
  }, []);

  if (loading) {
    return <div className="p-6 text-sm text-gray-500">Checking session…</div>;
  }
  if (!authed) {
    return <Navigate to="/family/login" replace />;
  }
  if (role !== "family_member") {
    return <Navigate to="/übersicht" replace />;
  }
  return <Outlet />;
}
